export class UserInfo {
    firstName: string;
    lastName: string;
    birthDate: Date;
}
